import {
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { ReactNode } from 'react';

import { ColorExtractFn } from '@/types/components/common';

import { getDataTestId } from '@/utils/browser';

import { StatusIcon } from '../../DataDisplay/StatusIcon';

import { ActionButton, ListActionItemContainer } from './ActionList.styled';

type ListActionItemProps = Readonly<{
  title: string;
  description?: ReactNode;
  descriptionColor?: ColorExtractFn;
  richDescription?: ReactNode;
  actionButton?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}>;

export function ListActionItem({
  title,
  description,
  richDescription,
  descriptionColor,
  actionButton,
  onClick,
  disabled,
}: ListActionItemProps) {
  const theme = useTheme();
  return (
    <ListActionItemContainer
      {...getDataTestId(`list-action-item-${title}`)}
      disabled={disabled}
    >
      <ListItemText
        primary={<Typography variant="h5">{title}</Typography>}
        secondary={
          <Typography
            variant="caption"
            color={
              descriptionColor
                ? descriptionColor(theme)
                : theme.palette.text.secondary
            }
          >
            {
              richDescription || description || '\xa0' // non-breaking character
            }
          </Typography>
        }
      />
      <ListItemButton>
        {actionButton !== undefined ? (
          actionButton
        ) : (
          <ActionButton
            disabled={disabled}
            onClick={onClick}
            {...getDataTestId('action-button')}
          >
            <StatusIcon value="" iconName="arrow-right" />
          </ActionButton>
        )}
      </ListItemButton>
    </ListActionItemContainer>
  );
}
